<p-button
  [text]="true"
  label="download all trips"
  icon="pi pi-file-excel"
  (onClick)="downloadList()"
  [loading]="loading"
/>
